import { Pipe, PipeTransform } from '@angular/core';
import { convertUTCDateToLocalDate } from '../utilities/date.helpers';

@Pipe({
    name: 'dateUtcToLocal',
    pure: true,
})
export class DateUtcToLocalPipe implements PipeTransform {
    transform(value: any, random: number): any {
        if (value) {
            let candidateUtc = new Date(value);
            let candidateLocal = convertUTCDateToLocalDate(candidateUtc);

            return candidateLocal;
        }

        return value;
    }
}
